(() => {
  angular.module('pims').directive('visitNotes', ["$log", "ngDialog", "Messages", "toastr", "Notifications", ($log, ngDialog, Messages, toastr, Notifications) => {
    'ngInject';

    return {
      restrict: 'A',

      link(scope, element, attrs) {
        const dataString = scope.$eval(attrs.visitNotes);
        element.on('click', () => {
          Messages.visitNotes(dataString);
        });
        scope.$on('$destroy', () => element.off());
      }

    };
  }]);
})();